export default {
      id: "save-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#save",
      toString: function () {
        return this.url;
      }
    }